import { inject, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PaginationService } from '../pagination.service';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class PaginationComponent {

  @Input()
  active: string;

  public paginationService: PaginationService = inject(PaginationService);
}
